exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.boxStyle[data-v-ade7bb74]{top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:7.733333rem;background:#fff;border-radius:.266667rem;padding:.8rem\n}\n.desc[data-v-ade7bb74]{font-size:.426667rem;font-weight:400;color:#5a5a5a;line-height:.64rem;margin-bottom:.8rem\n}\n.model_btn[data-v-ade7bb74]{background:#00c55d;box-shadow:0 .213333rem .426667rem 0 rgba(0,197,93,.4);border-radius:.64rem;width:100%;display:block;font-size:.426667rem;font-weight:500;height:1.28rem;color:#fff\n}\n.model_btn[data-v-ade7bb74]:active{background:#00ab51\n}\n.box[data-v-ade7bb74]{position:relative;margin:0 auto;z-index:2\n}", ""]);

// exports
